import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FirebaseService} from "../../services/firebase.service";
import {Entries} from 'bf-functions';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {IAuthorInList} from "../../common/interfaces";

interface EntryPromise {
  type_of_publication: string;
  year: string;
  html: Promise<SafeHtml>;
}

interface IEntriesByType {
  years_array: number[];
  entries: Map<string, SafeHtml[]>;
}
@Component({
  selector: 'app-authors-list-publications-detail',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    KeyValuePipe,
    NgForOf, NgIf
  ],
  providers:[FirebaseService],
  templateUrl: './authors-list-publications-detail.component.html',
  styleUrl: './authors-list-publications-detail.component.sass'
})
export class AuthorsListPublicationsDetailComponent  implements OnChanges{

  @Input() currentAuthor!: IAuthorInList;
  showSpinner: boolean = false;
  // this object represents sections of publications grouped by type. for each of them there is grouping by year
  protected publicationsData: Map<string, IEntriesByType> = new Map<string, IEntriesByType>();
  private readonly publications_sorting_order = {
    'journal-article' : 1,
    'book': 3,
    'book-chapter': 2,
    'conference-paper': 4,
    'unknown': 100};

  protected readonly publications_types = new Map<string, string>([
    ['article-journal', 'Articles in Journals'], ['book', 'Books'],
  ['chapter', 'Chapters in books and in conference proceedings'], ['conference-paper', 'Conference papers'],
  ['presentation', 'Presentation'],['unknown', 'Unknown type']]);

  constructor(private firebase: FirebaseService, private sanitizer: DomSanitizer) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.publicationsData.clear();

    if (changes['currentAuthor'] && this.currentAuthor && this.currentAuthor.id !== undefined && this.currentAuthor.id !== '') {
      this.showSpinner = true;
      // let sorted_publications_grouped_by_type = new Map<string, any>();
      this.firebase.getPublicationsForAuthor(this.currentAuthor.id).then((data: any) => {
        if (data === null) { // than there is not cached data!
          this.generateFauxPublicationsEntryNoCache();
          this.showSpinner = false;
        }
        else {
          Entries.arrangePublications(data).then(publications => {
            publications.forEach((entries_of_type_by_year, publication_type) => {
              const publications_years = Array.from(entries_of_type_by_year.keys()).map(a => parseInt(a))
                .sort((a, b) => b - a);
              this.publicationsData.set(publication_type, {years_array: publications_years, entries: entries_of_type_by_year});
            });
            this.showSpinner = false;
          });
        }
      });
    }
  }

  private generateFauxPublicationsEntryNoCache(): void {
    console.warn('No publications cache found for author:', this.currentAuthor.id);
    const publicationType = "Error: no cached data";
    const year = 1;
    const entry = this.sanitizer.bypassSecurityTrustHtml("no cached data for author");
    const entriesOfTypeByYear = new Map<string, SafeHtml[]>();
    entriesOfTypeByYear.set(String(year), [entry]);
    // const result = new Map<string, IEntriesByType>();
    this.publicationsData.set(publicationType, {
      years_array: [year],
      entries: entriesOfTypeByYear
    });
  }
}
